import {resources} from "../../../../../../../core/models/resource/resources";

export const websiteLinksResourceType = resources['website-links'];
